export default __webpack_public_path__ + "static/media/homepage_step_3.25d63e95.svg";